export default function SideSheetsFooter({ children }) {
  return (
    <div className="bg-white flex flex-col absolute bottom-0 items-center justify-center gap-4 px-6 py-4 w-full border-t-1 border-t-light-grey">
      {children}
    </div>
  );
}
